// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "989579274b05b279e9a2" + ".chunk.js";
};